function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 3V9H19V19H1V5H7V3L10 0L13 3ZM2.99951 17.0007H4.99951V15.0007H2.99951V17.0007ZM4.99951 12.9995H2.99951V10.9995H4.99951V12.9995ZM2.99951 9.00049H4.99951V7.00049H2.99951V9.00049ZM11.0002 17.0007H9.00024V15.0007H11.0002V17.0007ZM9.00024 12.9995H11.0002V10.9995H9.00024V12.9995ZM11.0002 9.00049H9.00024V7.00049H11.0002V9.00049ZM9.00024 4.99927H11.0002V2.99927H9.00024V4.99927ZM17.001 17.0007H15.001V15.0007H17.001V17.0007ZM15.001 12.9995H17.001V10.9995H15.001V12.9995Z",
  fill: "#222222"
});

var SvgCity = function SvgCity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/city.6aaf8a87.svg";
export { ForwardRef as ReactComponent };